<template>
  <div class="voucher__body-info">
    <div class="voucher__body-info__header">
      <div class="voucher__body-info__header-img__container">
        <img :src="analisePng" />
      </div>

      <div class="voucher__body-info__header-description">
        <span class="h5">Otimize sua gestão fiscal através de uma</span>
        <span class="h3">Análise Automatizada</span>

        <p>Veja créditos, débitos, pendências fiscais e muito mais!</p>
      </div>
    </div>

    <div class="voucher__body-info__contato">
      <el-form
        :model="form"
        label-width="auto"
        label-position="top"
        :rules="rules"
        ref="FormRef"
        label-postion="top"
        style="width: 100%"
      >
        <el-row style="width: 100%">
          <el-col :span="12">
            <el-form-item
              label="E-mail*"
              prop="email"
              style="margin-right: 10px; width: 100%"
            >
              <el-input
                v-model="form.email"
                placeholder="Digite aqui"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Whatsapp*" prop="whats" style="width: 100%">
              <el-input
                v-maska
                v-model="form.whats"
                data-maska="['(##) # ####-####','(##) ####-####']"
                placeholder="Digite aqui"
                :min="11"
                :maxlength="16"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" class="voucher__body-info__contato__termos">
            <label class="voucher__body-info__contato__termos-desc">
              <Elcheckbox
                v-model="form.termos"
                fill="#000"
                class="voucher__body-info__contato__termos-desc__check"
              />
              Aceito os
              <router-link :to="Termos" download="termos" rel="noopener">
                Termos e Condições
              </router-link>
            </label>
          </el-col>
        </el-row>
      </el-form>
      <div class="voucher__body-info__footer">
        <div class="voucher__body-info__footer-action">
          <vc-button
            :is-loading.camel="isLoading"
            type="primary"
            @click="handleForm"
            class="voucher__body-info__footer-action__button"
          >
            Aproveitar a oportunidade
          </vc-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import analisePng from "./analise.png";
import { reactive, ref } from "vue";
import useNotification from "../../../../composables/shared/notification/useNotification";
import Termos from "./termos.pdf";
import ElInput from "element-plus/es/components/input/index";
import ElForm from "element-plus/es/components/form/index";
import Elcheckbox from "element-plus/es/components/checkbox/index";
import { FormInstance, FormRules } from "element-plus";
import { vMaska } from "maska";

const phoneMask = /^\(\d{2}\)\s\d{1,2}\s\d{4,5}-\d{4,5}$/;

const notification = useNotification();

const emits = defineEmits<{
  (e: string, uri: typeof form): void;
}>();

withDefaults(
  defineProps<{
    isLoading: boolean;
  }>(),
  {
    isLoading: false
  }
);

const FormRef = ref<FormInstance>();

type IForm = {
  email: string | null;
  whats: string | null;
  termos: boolean;
};

const form = reactive<IForm>({
  email: null,
  whats: null,
  termos: false
});

interface Callback {
  (error?: Error): void;
}

const whatsValidator = (rule: unknown, value: string, callback: Callback) => {
  if (phoneMask.test(value)) {
    callback();
  } else {
    callback(new Error("Número de telefone inválido"));
  }
};

const rules = reactive<FormRules>({
  email: [{ type: "email", required: true, message: "", trigger: "blur" }],
  whats: [
    { required: true, message: "", trigger: "blur", validator: whatsValidator }
  ]
});

const handleForm = () => {
  const formRef = FormRef.value;
  formRef?.validate((valid) => {
    if (valid) {
      if (!form.termos) {
        notification.showNotification("Aceitar os termos e condições", {
          type: "error"
        });

        return;
      }

      emits("handleFormSubmitted", form);
    } else {
      notification.showNotification(
        "Preencha, todos os campos corretamente para continuar",
        { type: "error" }
      );
    }
  });
};
</script>
<style lang="scss">
@use "element-plus/theme-chalk/el-input.css";
@use "element-plus/theme-chalk/el-form.css";
@use "@/styles/theme/contabil-theme.scss" as *;

.voucher__body-info {
  padding: 0 24px 16px;
  width: 100%;
  box-sizing: border-box;

  .el-form-item.is-required:not(.is-no-asterisk).asterisk-left
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk).asterisk-left
    > .el-form-item__label-wrap
    > .el-form-item__label:before {
    display: none;
  }

  .el-input {
    --el-input-focus-border-color: #09de73;
  }

  &__header {
    display: flex;
    gap: 8px;

    &-description {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      span.h5 {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        margin: 0;
        padding: 0;
        color: #2e2e2e;
      }

      span.h3 {
        margin: 0;
        padding: 0;
        line-height: 30px;
        font-size: 24px;
        font-weight: 700;
        color: #2e2e2e;
      }

      p {
        margin: 0;
        padding: 0;
        margin-top: 16px;
        color: #4f4f4f;
        font-size: 12px;
        font-weight: 300;
        line-height: 16px;
        text-align: center;
      }
    }
  }

  &__contato {
    padding: 24px 64px 0;

    h4 {
      color: #3d3d3d;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
    }

    .el-form {
      &-item {
        margin-bottom: 5px;

        .el-input__inner {
          font-size: 12px;
        }

        &__label {
          margin: 0;
          color: #2e2e2e;
          line-height: 10px;
          font-size: 12px;
          font-weight: 400;
          margin-bottom: -1px !important;
        }
      }
    }

    &__termos {
      margin-top: 16px;
      width: 100%;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      &-desc {
        color: #2e2e2e;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        display: flex;
        align-items: center;

        &__check {
          margin: 0;
          margin-right: 8px;
          cursor: pointer;
        }

        a {
          text-decoration: underline;
          color: #04904a;
          cursor: pointer;
          margin-left: 3px;
        }
      }
    }
  }

  &__footer {
    width: 100%;

    &-action {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      &__button {
        background-color: #00cc66;
      }
    }

    &-obs {
      margin-top: 8px;
      color: #6d6d6d;
      font-size: 12px;
      font-weight: 300;
      line-height: 16px;
      text-align: center;
    }
  }
}
</style>
